function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError503({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.28,
    y: 391.92,
    width: 26,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.15,
    y: 389.21,
    width: 45.03,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.28,
    y: 401.21,
    width: 60.79,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.49,
    y: 399.53,
    width: 19.23,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.29,
    y: 399.53,
    width: 55.29,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.05,
    y: 395.31,
    width: 74.47,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.83,215.44l-12.65,167h122l12.65-167Zm76.71,118A27.06,27.06,0,0,1,241,358.11a22.54,22.54,0,0,1-22.79-24.66l4.45-58.7a27.06,27.06,0,0,1,26.53-24.67A22.55,22.55,0,0,1,272,274.75Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.88 382.4 161 382.4 162.03 371.44 339.9 371.44 338.88 382.4",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.22,320.41H423a1.55,1.55,0,0,0,1.55-1.64l-.06-1.12a1.73,1.73,0,0,0-1.71-1.63H407a1.55,1.55,0,0,0-1.56,1.63l.06,1.12A1.74,1.74,0,0,0,407.22,320.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.89,320.41h15.75a1.54,1.54,0,0,0,1.55-1.64l-.06-1.12a1.73,1.73,0,0,0-1.71-1.63H380.67a1.55,1.55,0,0,0-1.56,1.63l.06,1.12A1.75,1.75,0,0,0,380.89,320.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.23,319.17H67.6a8.16,8.16,0,0,1-8.06-7.68L48.47,90.67A7.22,7.22,0,0,1,55.76,83H423.39a8.15,8.15,0,0,1,8.06,7.67l11.07,220.82A7.23,7.23,0,0,1,435.23,319.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.73,319.17H72.11A8.18,8.18,0,0,1,64,311.49L53,90.67A7.22,7.22,0,0,1,60.27,83H427.89A8.17,8.17,0,0,1,436,90.67L447,311.49A7.23,7.23,0,0,1,439.73,319.17Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.26,303.76,64,98.41a4.54,4.54,0,0,1,4.57-4.81H420.69a5.1,5.1,0,0,1,5.05,4.81L436,303.76a4.53,4.53,0,0,1-4.56,4.81H79.31A5.11,5.11,0,0,1,74.26,303.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.66,104.1a4,4,0,0,1-4,4.26,4.53,4.53,0,0,1-4.47-4.26,4,4,0,0,1,4-4.25A4.51,4.51,0,0,1,85.66,104.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.93,104.1a4,4,0,0,1-4,4.26,4.53,4.53,0,0,1-4.47-4.26,4,4,0,0,1,4-4.25A4.51,4.51,0,0,1,104.93,104.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.21,104.1a4,4,0,0,1-4,4.26,4.51,4.51,0,0,1-4.46-4.26,4,4,0,0,1,4-4.25A4.52,4.52,0,0,1,124.21,104.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "110.88 308.57 161.63 308.57 208.03 93.6 157.28 93.6 110.88 308.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.28 308.57 342.13 308.57 388.53 93.6 375.68 93.6 329.28 308.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.91 308.57 244.91 308.57 291.31 93.6 219.31 93.6 172.91 308.57",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.6,263.05h-.36c-26.64-2.18-45-25-45.74-25.92a4.47,4.47,0,0,1,7-5.55c.21.27,15.9,19.61,37.63,22.37,7-7,13-25.48,12.33-31.07,0-.06,0-.11,0-.16-.14-1.8-.48-8,1.29-11.65a4.47,4.47,0,0,1,8,3.88c-.44.92-.65,4.23-.44,7,1,9.2-7,32.42-17,40.19A4.47,4.47,0,0,1,360.6,263.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.82,238.82a65.8,65.8,0,0,1-48.56-22.28,4.46,4.46,0,0,1-.26-5.64c7.22-9.71,20-32.64,22-40.11a10.91,10.91,0,0,0-4.14-4.33,4.45,4.45,0,0,1-2.55-3.61l-.72-7.32a4.47,4.47,0,0,1,8.89-.88l.5,5.09a22.34,22.34,0,0,1,6.81,8.65,4.48,4.48,0,0,1,.32,2.26c-.92,7.93-13.79,30.9-21.71,42.51,18.49,18.43,40.59,16.75,41.56,16.66a4.47,4.47,0,0,1,.82,8.9C151.52,238.74,150.49,238.82,148.82,238.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.87,416.09h-12a4.47,4.47,0,0,1-4.31-5.66c3.13-11.24,4.67-20.39,5.82-34.71-4.24-20-8.23-38.21-8.27-38.39a4.47,4.47,0,0,1,8.73-1.91c0,.18,4.12,18.86,8.41,39.08a4.23,4.23,0,0,1,.08,1.28c-1,12.86-2.31,21.75-4.67,31.38h6.18a4.47,4.47,0,0,1,0,8.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.32,416.09h-6.76a4.45,4.45,0,0,1-4.42-5.08c1.15-8.2,7-23.13,13.3-38.14,2.23-19.8,4.05-36.8,4.07-37a4.47,4.47,0,1,1,8.88,1c0,.17-1.88,17.56-4.15,37.65a4.31,4.31,0,0,1-.32,1.22c-4.43,10.63-9.49,23.15-11.8,31.44h1.2a4.47,4.47,0,1,1,0,8.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.21,111l-52.06,52.07c-2.62,57.71-2.41,118.33,0,181.18H324.31c-3.41-81.1-3.73-159.17,0-233.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.31,345.13H152.15a.9.9,0,0,1-.9-.86C148.76,279,148.76,218,151.25,163a.9.9,0,0,1,.27-.59l52.06-52.07a.89.89,0,0,1,.63-.26h120.1a.9.9,0,0,1,.65.28.87.87,0,0,1,.24.66c-3.59,71.34-3.59,147.61,0,233.17a.89.89,0,0,1-.25.65A.86.86,0,0,1,324.31,345.13ZM153,343.34H323.38c-3.54-84.86-3.55-160.59,0-231.47H204.58L153,163.43C150.55,218.07,150.55,278.59,153,343.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.85,287.4l1.88-.16a4.24,4.24,0,0,0,.71,1.86,3.7,3.7,0,0,0,1.58,1.17,5.87,5.87,0,0,0,2.33.45,5.39,5.39,0,0,0,2-.34,2.63,2.63,0,0,0,1.25-.93,2.09,2.09,0,0,0,.37-1.29,2,2,0,0,0-.47-1.24,3.11,3.11,0,0,0-1.4-.89,26.14,26.14,0,0,0-2.73-.74,14.42,14.42,0,0,1-2.95-.94,4.4,4.4,0,0,1-1.68-1.41,3.54,3.54,0,0,1-.62-1.88,3.67,3.67,0,0,1,2.37-3.64,6.83,6.83,0,0,1,2.74-.52,7.81,7.81,0,0,1,3,.54,4.54,4.54,0,0,1,2,1.59,4.76,4.76,0,0,1,.86,2.38l-1.91.15a3.27,3.27,0,0,0-1.15-2.17,4.23,4.23,0,0,0-2.66-.73,4,4,0,0,0-2.61.67,1.88,1.88,0,0,0-.75,1.6,1.79,1.79,0,0,0,.65,1.34,8.2,8.2,0,0,0,3.06,1.07,20.42,20.42,0,0,1,3.39,1,4.85,4.85,0,0,1,2,1.53,3.94,3.94,0,0,1,.73,2.15,4,4,0,0,1-.58,2.27,4.28,4.28,0,0,1-1.91,1.66,6.77,6.77,0,0,1-2.88.59,9.06,9.06,0,0,1-3.46-.59,5.22,5.22,0,0,1-2.26-1.8A5.41,5.41,0,0,1,202.85,287.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.91,288.73l1.93.24a4.35,4.35,0,0,1-1.56,2.6,4.81,4.81,0,0,1-3.08.93,5.24,5.24,0,0,1-3.88-1.48,6,6,0,0,1-1.6-4.14,5.82,5.82,0,0,1,1.21-4.28,4.59,4.59,0,0,1,3.62-1.53,4.88,4.88,0,0,1,3.65,1.5,6.12,6.12,0,0,1,1.59,4.2c0,.11,0,.27,0,.49h-8.16A4.45,4.45,0,0,0,219.8,290a3.18,3.18,0,0,0,2.33,1,2.72,2.72,0,0,0,1.72-.54A3.31,3.31,0,0,0,224.91,288.73Zm-6.23-3h6.11a4,4,0,0,0-.8-2.07,3,3,0,0,0-2.35-1.07,2.83,2.83,0,0,0-2.11.85A3.25,3.25,0,0,0,218.68,285.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.3,292.25l-.52-10.93h1.66l.08,1.66a4.25,4.25,0,0,1,1.11-1.54,2,2,0,0,1,1.17-.37,3.71,3.71,0,0,1,1.93.6l-.55,1.72a2.75,2.75,0,0,0-1.38-.4,1.69,1.69,0,0,0-1.07.36,1.78,1.78,0,0,0-.64,1,6.84,6.84,0,0,0-.21,2.16l.27,5.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.38,292.25l-4.68-10.93h2l2.66,6.55c.29.71.56,1.44.81,2.2.14-.57.33-1.27.59-2.08l2.11-6.67h1.91l-3.62,10.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.28,279.29l-.11-2.13H248l.1,2.13Zm.62,13-.53-10.93h1.86l.52,10.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.51,288.25l1.84.24a4.48,4.48,0,0,1-1.39,2.95,4.27,4.27,0,0,1-3,1.06,4.92,4.92,0,0,1-3.68-1.47,6.19,6.19,0,0,1-1.57-4.2,7.52,7.52,0,0,1,.44-3.1,3.83,3.83,0,0,1,1.69-2,5.07,5.07,0,0,1,2.58-.67,4.72,4.72,0,0,1,3,.9,4.39,4.39,0,0,1,1.57,2.56l-1.78.28a3.25,3.25,0,0,0-1-1.66,2.48,2.48,0,0,0-1.61-.55,2.73,2.73,0,0,0-2.23,1,4.62,4.62,0,0,0-.72,3.18,5.15,5.15,0,0,0,1,3.2,2.93,2.93,0,0,0,2.26,1,2.53,2.53,0,0,0,1.79-.67A3.16,3.16,0,0,0,258.51,288.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.43,288.73l1.93.24a4.35,4.35,0,0,1-1.56,2.6,4.81,4.81,0,0,1-3.08.93,5.24,5.24,0,0,1-3.88-1.48,6.05,6.05,0,0,1-1.6-4.14,5.78,5.78,0,0,1,1.22-4.28,4.56,4.56,0,0,1,3.61-1.53,4.88,4.88,0,0,1,3.65,1.5,6.12,6.12,0,0,1,1.59,4.2c0,.11,0,.27,0,.49h-8.16a4.45,4.45,0,0,0,1.15,2.76,3.2,3.2,0,0,0,2.34,1,2.69,2.69,0,0,0,1.71-.54A3.31,3.31,0,0,0,269.43,288.73Zm-6.23-3h6.11a3.88,3.88,0,0,0-.8-2.07,3,3,0,0,0-2.35-1.07,2.79,2.79,0,0,0-2.1.85A3.22,3.22,0,0,0,263.2,285.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.52,313.34l-.08-1.61a3.78,3.78,0,0,1-3.38,1.86,4.67,4.67,0,0,1-1.83-.37,3.26,3.26,0,0,1-1.29-.93,3.65,3.65,0,0,1-.63-1.38,9,9,0,0,1-.2-1.73l-.33-6.77h1.86l.29,6.06a10.49,10.49,0,0,0,.21,2,2.06,2.06,0,0,0,.79,1.15,2.45,2.45,0,0,0,1.42.41,2.92,2.92,0,0,0,1.55-.43,2.22,2.22,0,0,0,1-1.16,6,6,0,0,0,.2-2.14l-.28-5.85h1.85l.52,10.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.08,313.34l-.53-10.93h1.67l.08,1.55a3.71,3.71,0,0,1,3.39-1.8,4.77,4.77,0,0,1,1.83.35,3,3,0,0,1,1.29.94,3.69,3.69,0,0,1,.64,1.37,10,10,0,0,1,.19,1.8l.32,6.72h-1.85l-.32-6.65a4.92,4.92,0,0,0-.3-1.69,1.86,1.86,0,0,0-.81-.9,2.52,2.52,0,0,0-1.3-.34,2.89,2.89,0,0,0-2,.76,3.59,3.59,0,0,0-.73,2.85l.29,6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.88,312a6.33,6.33,0,0,1-1.93,1.24,5.57,5.57,0,0,1-2,.36,4.19,4.19,0,0,1-2.82-.88,3.06,3.06,0,0,1-1.07-2.25,2.88,2.88,0,0,1,.29-1.47,3,3,0,0,1,.91-1.07,4.56,4.56,0,0,1,1.3-.6,12.46,12.46,0,0,1,1.64-.28,16.19,16.19,0,0,0,3.27-.64c0-.25,0-.41,0-.48a2.18,2.18,0,0,0-.6-1.6,4.06,4.06,0,0,0-4.05-.17,2.66,2.66,0,0,0-.84,1.62l-1.83-.24a4.19,4.19,0,0,1,.73-1.88,3.32,3.32,0,0,1,1.58-1.11,7.31,7.31,0,0,1,2.46-.38,6.65,6.65,0,0,1,2.29.33,2.78,2.78,0,0,1,2,2.09,11.51,11.51,0,0,1,.17,1.71l.12,2.47a26.67,26.67,0,0,0,.27,3.27,4.49,4.49,0,0,0,.54,1.31h-1.94A3.83,3.83,0,0,1,216.88,312Zm-.36-4.14a12.68,12.68,0,0,1-3,.7,7.17,7.17,0,0,0-1.6.37,1.5,1.5,0,0,0-.7.61,1.54,1.54,0,0,0-.22.88,1.68,1.68,0,0,0,.62,1.23,2.52,2.52,0,0,0,1.67.5,3.72,3.72,0,0,0,1.88-.47,2.73,2.73,0,0,0,1.17-1.28,4.73,4.73,0,0,0,.21-1.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.57,313.34l-4.68-10.93h2L224.5,309c.29.71.56,1.45.81,2.21.14-.58.33-1.27.59-2.08l2.11-6.67h1.9l-3.61,10.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.15,312a6.33,6.33,0,0,1-1.93,1.24,5.57,5.57,0,0,1-2,.36,4.17,4.17,0,0,1-2.81-.88,3,3,0,0,1-1.08-2.25,2.88,2.88,0,0,1,.29-1.47,3,3,0,0,1,.91-1.07,4.49,4.49,0,0,1,1.31-.6,12,12,0,0,1,1.63-.28,16.19,16.19,0,0,0,3.27-.64c0-.25,0-.41,0-.48a2.14,2.14,0,0,0-.6-1.6,4.06,4.06,0,0,0-4.05-.17,2.66,2.66,0,0,0-.84,1.62l-1.83-.24a4.19,4.19,0,0,1,.73-1.88,3.32,3.32,0,0,1,1.58-1.11,7.31,7.31,0,0,1,2.46-.38,6.65,6.65,0,0,1,2.29.33,2.78,2.78,0,0,1,2,2.09,10.26,10.26,0,0,1,.17,1.71l.12,2.47A25.89,25.89,0,0,0,241,312a4.2,4.2,0,0,0,.53,1.31h-1.94A4,4,0,0,1,239.15,312Zm-.36-4.14a12.68,12.68,0,0,1-3,.7,7.17,7.17,0,0,0-1.6.37,1.5,1.5,0,0,0-.7.61,1.54,1.54,0,0,0-.22.88,1.68,1.68,0,0,0,.62,1.23,2.52,2.52,0,0,0,1.67.5,3.72,3.72,0,0,0,1.88-.47,2.73,2.73,0,0,0,1.17-1.28,4.39,4.39,0,0,0,.21-1.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.19,300.38l-.1-2.13h1.85l.11,2.13Zm.62,13-.52-10.93h1.85l.53,10.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.45,313.34l-.73-15.09h1.86l.72,15.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.24,312a6.29,6.29,0,0,1-1.92,1.24,5.59,5.59,0,0,1-2,.36,4.18,4.18,0,0,1-2.81-.88,3.06,3.06,0,0,1-1.07-2.25,2.88,2.88,0,0,1,1.2-2.54,4.43,4.43,0,0,1,1.3-.6,12.46,12.46,0,0,1,1.64-.28,16.34,16.34,0,0,0,3.27-.64c0-.25,0-.41,0-.48a2.18,2.18,0,0,0-.6-1.6,3.23,3.23,0,0,0-2.14-.63,3.19,3.19,0,0,0-1.91.46,2.71,2.71,0,0,0-.85,1.62l-1.82-.24a4.3,4.3,0,0,1,.72-1.88,3.4,3.4,0,0,1,1.59-1.11,7.31,7.31,0,0,1,2.46-.38,6.69,6.69,0,0,1,2.29.33,2.78,2.78,0,0,1,2,2.09,11.51,11.51,0,0,1,.17,1.71l.12,2.47a26.67,26.67,0,0,0,.27,3.27,4.46,4.46,0,0,0,.53,1.31h-1.93A4,4,0,0,1,260.24,312Zm-.35-4.14a12.81,12.81,0,0,1-3,.7,7.17,7.17,0,0,0-1.6.37,1.45,1.45,0,0,0-.7.61,1.54,1.54,0,0,0-.22.88,1.65,1.65,0,0,0,.62,1.23,2.52,2.52,0,0,0,1.67.5,3.72,3.72,0,0,0,1.88-.47,2.66,2.66,0,0,0,1.16-1.28,4.39,4.39,0,0,0,.21-1.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.61,313.34h-1.72l-.72-15.09H266l.26,5.38a3.47,3.47,0,0,1,2.92-1.47,4.55,4.55,0,0,1,1.93.41,4.11,4.11,0,0,1,1.54,1.14,6.05,6.05,0,0,1,1,1.77,7.42,7.42,0,0,1,.43,2.23,6,6,0,0,1-1.18,4.34,4.11,4.11,0,0,1-3.26,1.54,3.69,3.69,0,0,1-3.12-1.62Zm-.29-5.55a6,6,0,0,0,.67,2.84,2.82,2.82,0,0,0,2.44,1.43,2.54,2.54,0,0,0,2.05-1.05,4.66,4.66,0,0,0,.74-3.15,5.15,5.15,0,0,0-1-3.16,2.73,2.73,0,0,0-2.11-1,2.55,2.55,0,0,0-2.05,1.06A4.52,4.52,0,0,0,266.32,307.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.59,313.34l-.73-15.09h1.86l.72,15.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.63,309.82l1.93.24a4.41,4.41,0,0,1-1.56,2.6,4.83,4.83,0,0,1-3.08.93,5.28,5.28,0,0,1-3.88-1.48,6,6,0,0,1-1.6-4.14,5.81,5.81,0,0,1,1.21-4.29,4.62,4.62,0,0,1,3.62-1.52,4.91,4.91,0,0,1,3.65,1.49,6.16,6.16,0,0,1,1.59,4.2c0,.11,0,.28,0,.5h-8.16a4.45,4.45,0,0,0,1.15,2.76,3.17,3.17,0,0,0,2.33.95,2.79,2.79,0,0,0,1.72-.53A3.42,3.42,0,0,0,288.63,309.82Zm-6.23-3h6.11a4,4,0,0,0-.8-2.07,3,3,0,0,0-2.35-1.07,2.83,2.83,0,0,0-2.11.86A3.25,3.25,0,0,0,282.4,306.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.44,319.46H274.66a.67.67,0,0,1-.67-.67.66.66,0,0,1,.67-.66h18.78a.66.66,0,0,1,.67.66A.67.67,0,0,1,293.44,319.46Z",
    style: {
      fill: "#0C6564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.88,319.46H183a.67.67,0,0,1-.67-.67.66.66,0,0,1,.67-.66h83.86a.66.66,0,0,1,.67.66A.67.67,0,0,1,266.88,319.46Z",
    style: {
      fill: "#0C6564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.28,219.19c-.2-4.36-2.67-7.8-5.53-7.7s-5,3.71-4.82,8.07,2.67,7.8,5.53,7.69S214.48,223.54,214.28,219.19Z",
    style: {
      fill: "#0C6564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.65,217.82c-.2-4.35-2.67-7.79-5.53-7.69s-5,3.71-4.82,8.07,2.68,7.8,5.53,7.69S274.85,222.18,274.65,217.82Z",
    style: {
      fill: "#0C6564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.35,237a36.55,36.55,0,0,1,28.63,1.3,1.27,1.27,0,0,1,.49,1.74,1.3,1.3,0,0,1-1.75.49c-.15-.08-14.4-7.76-31.41,1a1.31,1.31,0,0,1-1.74-.54,1.27,1.27,0,0,1,.55-1.72A41.73,41.73,0,0,1,229.35,237Z",
    style: {
      fill: "#0C6564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.64,178.34a2.64,2.64,0,0,1,1.26.36,2.58,2.58,0,0,1,.92,3.51A25.29,25.29,0,0,1,188.27,195a2.59,2.59,0,0,1-2.69-2.45,2.55,2.55,0,0,1,2.44-2.66h0c.39,0,9.62-.58,15.36-10.27A2.52,2.52,0,0,1,205.64,178.34Z",
    style: {
      fill: "#0C6564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.05,176.87a2.57,2.57,0,0,1,2.33.72c8,8,17.14,6.39,17.52,6.32a2.6,2.6,0,0,1,3,2,2.54,2.54,0,0,1-2,3c-.5.09-12.14,2.31-22.21-7.75a2.54,2.54,0,0,1,1.31-4.3Z",
    style: {
      fill: "#0C6564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.72,204.86l-7.31.68a5.22,5.22,0,0,1-5.58-4.06L298.7,156.1a5.22,5.22,0,0,1,3.77-6.18l19.59-5.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,167.69c-5.09-13.89-10.18-36.12-4.81-56.71l-52.06,52.07C166.86,168,190.32,170.11,209,167.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.21,163.05c-5.71-16.86-3.38-39.78,0-52.07l-52.06,52.07C167.91,165.92,185.52,165.46,204.21,163.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,165.92a133.14,133.14,0,0,1-24-2,.88.88,0,0,1-.47-1.5l52.06-52.07a.89.89,0,0,1,1.49.87c-3.14,11.44-5.75,34.6,0,51.54a.93.93,0,0,1-.09.76.87.87,0,0,1-.64.41A221.85,221.85,0,0,1,176,165.92Zm-22-3.46c13.84,2.29,29.91,2.24,49-.16-4.71-14.94-3.64-34.71-.48-48.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1,239.11a1.49,1.49,0,0,1-1.44-1.11l-18.34-69.88a1.49,1.49,0,0,1,2.89-.76l18.34,69.88a1.49,1.49,0,0,1-1.07,1.82A1.2,1.2,0,0,1,383.1,239.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.35,
    y: 136.8,
    width: 1,
    height: 5.51,
    transform: "matrix(0.97, -0.25, 0.25, 0.97, -21.77, 110.37)",
    style: {
      fill: "#0C6564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.11,131.09l-3.85-14.67a7.76,7.76,0,0,0-9.46-5.53l-10.07,2.64-.25-1,10.07-2.65a8.76,8.76,0,0,1,10.67,6.24l3.86,14.68Z",
    style: {
      fill: "#0C6564"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.61,
    y: 124.87,
    width: 109.05,
    height: 58.03,
    rx: 5.24,
    transform: "translate(-27.23 96.7) rotate(-14.7)",
    style: {
      fill: "#0C6564"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.5,
    y: 174.37,
    width: 72.67,
    height: 25.34,
    rx: 5.24,
    transform: "translate(-35.36 99.99) rotate(-14.7)",
    style: {
      fill: "#0C6564"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.15,187.94l8.23-2.14.55,2.12-5.15,1.34.41,1.58L351,189.6l.53,2-4.78,1.25.51,1.95,5.3-1.37.58,2.25-8.37,2.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.81,195.26l-2.59-9.94,5.12-1.33a7.66,7.66,0,0,1,2.24-.32,2.39,2.39,0,0,1,1.45.59,3.15,3.15,0,0,1,.9,3,2.75,2.75,0,0,1-.72,1.23,3.69,3.69,0,0,1-1,.67,2.09,2.09,0,0,1,1.52.56,5,5,0,0,1,.6.5l2.23,2.49-3.47.91L358.68,191a2.32,2.32,0,0,0-.75-.62,1.35,1.35,0,0,0-.82,0l-.27.07,1.05,4Zm1.54-6.72,1.3-.33a4.8,4.8,0,0,0,.78-.35.8.8,0,0,0,.41-.44,1,1,0,0,0-.45-1.29,2,2,0,0,0-1.21,0l-1.35.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.6,192.45,363,182.51l5.12-1.33a8,8,0,0,1,2.24-.32,2.37,2.37,0,0,1,1.44.59,2.76,2.76,0,0,1,.88,1.49,2.81,2.81,0,0,1,0,1.52,2.85,2.85,0,0,1-.71,1.22,4.14,4.14,0,0,1-1,.68,2.89,2.89,0,0,1,.89.15,3.47,3.47,0,0,1,.63.4,4.68,4.68,0,0,1,.59.5l2.24,2.5-3.47.9-2.43-2.61a2.24,2.24,0,0,0-.76-.62,1.32,1.32,0,0,0-.81,0l-.27.07,1.05,4Zm1.55-6.71,1.3-.34a5.28,5.28,0,0,0,.77-.35.79.79,0,0,0,.42-.44,1,1,0,0,0-.45-1.28,1.89,1.89,0,0,0-1.22,0l-1.34.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.45,184.85a4.86,4.86,0,0,1,3.79-6.48,5.4,5.4,0,0,1,4.17.34,5.23,5.23,0,0,1,2.31,3.38,6.45,6.45,0,0,1,.16,3,4.29,4.29,0,0,1-1.25,2.18,5.82,5.82,0,0,1-2.6,1.34,6.51,6.51,0,0,1-2.92.18,4.3,4.3,0,0,1-2.23-1.22A5.92,5.92,0,0,1,374.45,184.85Zm3.07-.78a3.4,3.4,0,0,0,1.12,2,2.18,2.18,0,0,0,3.06-.78,3.79,3.79,0,0,0-.06-2.45,3.15,3.15,0,0,0-1.1-1.9,2,2,0,0,0-1.7-.25,1.92,1.92,0,0,0-1.32,1.05A3.47,3.47,0,0,0,377.52,184.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.73,186.69l-2.59-9.93,5.12-1.33a7.29,7.29,0,0,1,2.24-.32,2.36,2.36,0,0,1,1.45.59,3.11,3.11,0,0,1,.89,3,2.88,2.88,0,0,1-.71,1.23,3.69,3.69,0,0,1-1,.67,3.24,3.24,0,0,1,.9.16,3.08,3.08,0,0,1,.62.39,4,4,0,0,1,.59.51l2.24,2.49-3.47.91-2.43-2.61a2.43,2.43,0,0,0-.76-.63,1.39,1.39,0,0,0-.81,0l-.27.07,1.05,4Zm1.54-6.71,1.3-.33a5.94,5.94,0,0,0,.78-.35.84.84,0,0,0,.41-.44,1,1,0,0,0-.45-1.29,1.93,1.93,0,0,0-1.21,0l-1.35.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.74,148.24l20.7-5.44,1.82,7-14,3.68.49,4.91a15.17,15.17,0,0,1,2.61-1.79,13.06,13.06,0,0,1,2.72-1.08,10.9,10.9,0,0,1,8.39.84,9.94,9.94,0,0,1,4.82,6.41,12.67,12.67,0,0,1,0,6.24,10.62,10.62,0,0,1-3.16,5.4,15.53,15.53,0,0,1-6.71,3.34,22,22,0,0,1-5.47.81,11.23,11.23,0,0,1-4.23-.77,11,11,0,0,1-3.21-2,14.42,14.42,0,0,1-2.57-3.26l8.57-3.28a5.54,5.54,0,0,0,2.34,2.83,4.11,4.11,0,0,0,3.09.36,3.92,3.92,0,0,0,2.65-2.17,6.37,6.37,0,0,0,.11-4.43,6.17,6.17,0,0,0-2.28-3.8,4.26,4.26,0,0,0-3.53-.46,5.37,5.37,0,0,0-2.28,1.26,7.12,7.12,0,0,0-1.5,2.13l-7.71.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.53,157.05q-2.36-8.94-.07-13.37t8.88-6.15a15.17,15.17,0,0,1,5.41-.58,10.07,10.07,0,0,1,3.85,1.16,11,11,0,0,1,2.71,2.11,14.21,14.21,0,0,1,2,2.91,30.62,30.62,0,0,1,2.79,7.09q2.25,8.53.4,13.26t-8.92,6.57a14.37,14.37,0,0,1-6.73.41,10.71,10.71,0,0,1-5-2.65,14.44,14.44,0,0,1-3-4.28A34,34,0,0,1,348.53,157.05Zm8.65-2.25q1.57,6,3.21,7.91A3.44,3.44,0,0,0,364,164.1a3.3,3.3,0,0,0,2-1.53,6,6,0,0,0,.67-3.32,32,32,0,0,0-1.19-6.4q-1.63-6.24-3.26-8.12a3.52,3.52,0,0,0-3.75-1.32,3.37,3.37,0,0,0-2.55,3C355.76,148.06,356.14,150.85,357.18,154.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.52,140.67l-8.63.69a10.71,10.71,0,0,1,2.37-7.07c1.58-1.91,4.15-3.34,7.72-4.27q6.15-1.62,9.49,0a7.45,7.45,0,0,1,4.25,5,6.71,6.71,0,0,1-.15,4,9.76,9.76,0,0,1-2.6,3.77,10.25,10.25,0,0,1,3.06.32,7,7,0,0,1,3.09,1.9,7.94,7.94,0,0,1,1.85,3.53,10.87,10.87,0,0,1-.05,5.63,10,10,0,0,1-3.12,5,16.33,16.33,0,0,1-6.72,3.22,18.94,18.94,0,0,1-7,.76,10.33,10.33,0,0,1-4.84-1.87,13.89,13.89,0,0,1-3.73-4.23l8.41-3.44a7,7,0,0,0,2.55,3.23,4,4,0,0,0,3,.3,3.92,3.92,0,0,0,2.58-2.06,5,5,0,0,0,.27-3.73,4.89,4.89,0,0,0-2-3.08,4.08,4.08,0,0,0-3.37-.4,11.75,11.75,0,0,0-2.69,1.25l-1.18-6.34a9.6,9.6,0,0,0,1.16-.19,4.12,4.12,0,0,0,2.57-1.85,3.55,3.55,0,0,0,.47-2.89,3.2,3.2,0,0,0-1.46-2.06,3.3,3.3,0,0,0-2.58-.24,3.57,3.57,0,0,0-2.26,1.59A5.81,5.81,0,0,0,384.52,140.67Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError503);
export default __webpack_public_path__ + "static/media/error503.0d541943b07ab3f4f90de37f9277f5e2.svg";
export { ForwardRef as ReactComponent };